import { render, staticRenderFns } from "./book-attendance.vue?vue&type=template&id=9b7d12f6&scoped=true"
import script from "./book-attendance.vue?vue&type=script&lang=js"
export * from "./book-attendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7d12f6",
  null
  
)

export default component.exports